<div class="content-margin my-team-page">
  <header class="my-team-header">
    <div class="my-team-title">
      <h1 class="ewrs-page-title">My team</h1>
      <button
        type="button"
        class="my-team-tooltip-trigger"
        mat-icon-button
        [matTooltip]="teamListTooltip"
        matTooltipPosition="right"
        [attr.aria-label]="teamListTooltip"
      >
        <mat-icon aria-hidden="true">info</mat-icon>
      </button>
    </div>
  </header>

  <mat-tab-group
    class="my-team-tabs"
    animationDuration="0ms"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [selectedIndex]="selectedTabIndex"
    (selectedIndexChange)="onTabChange($event)"
    aria-label="Select team view period"
  >
    <mat-tab label="Today">
      <ng-container *ngTemplateOutlet="todayView"></ng-container>
    </mat-tab>
    <mat-tab *ngIf="showThisWeekTab" label="This week">
      <ng-container
        *ngTemplateOutlet="weekView; context: { $implicit: thisWeek, headingId: 'thisWeekHeading' }"
      ></ng-container>
    </mat-tab>
    <mat-tab label="Last week">
      <ng-container
        *ngTemplateOutlet="weekView; context: { $implicit: lastWeek, headingId: 'lastWeekHeading' }"
      ></ng-container>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #todayView>
  <section class="my-team-statistics" aria-labelledby="teamStatisticsHeading">
    <h2 class="ewrs-section-title" id="teamStatisticsHeading">Today's statistics</h2>

    <div class="statistics-grid" aria-label="Today's team check-in statistics">
      <article class="stat-card stat-card--confirmed">
        <p class="stat-card__label">Confirmed On-Site</p>
        <p class="stat-card__value">{{ statistics.confirmedOnSite }}</p>
      </article>

      <article class="stat-card stat-card--missed">
        <p class="stat-card__label">Missed Checked-Ins</p>
        <p class="stat-card__value">{{ statistics.missedCheckIns }}</p>
      </article>

      <article class="stat-card stat-card--booked">
        <p class="stat-card__label">Booked</p>
        <p class="stat-card__value">{{ statistics.booked }}</p>
      </article>

      <article class="stat-card stat-card--none">
        <p class="stat-card__label">No Booking</p>
        <p class="stat-card__value">{{ statistics.noBooking }}</p>
      </article>
    </div>
  </section>

  <section class="team-location-section" aria-labelledby="todayHeading">
    <app-table
      [heading]="(today | date: 'd MMM y') || ''"
      headingId="todayHeading"
      [dataSource]="pagedTeamRows"
      [columns]="teamTableColumns"
      [length]="teamRows.length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [showRangeSummary]="true"
      [resultNoun]="'results'"
      [rowHeight]="80"
      [headerRowHeight]="44"
      [rowId]="teamRowId"
      [rowHover]="false"
      [noDataText]="noDataText(isLoading, teamLoaded)"
      (pageChanged)="onPageChanged($event)"
    >
      <div tableFooter class="team-table-footer">
        <ng-container *ngTemplateOutlet="statusLegend"></ng-container>
      </div>
    </app-table>
  </section>
</ng-template>

<ng-template #weekView let-week let-headingId="headingId">
  <section class="team-location-section" [attr.aria-labelledby]="headingId">
    <app-table
      [heading]="week.rangeLabel"
      [headingId]="headingId"
      [dataSource]="week.pagedRows"
      [columns]="week.columns"
      [length]="week.rows.length"
      [pageIndex]="week.pageIndex"
      [pageSize]="week.pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [showRangeSummary]="true"
      [resultNoun]="'results'"
      [rowHeight]="80"
      [headerRowHeight]="44"
      [rowId]="weekRowId"
      [rowHover]="false"
      [noDataText]="noDataText(week.isLoading, week.loaded)"
      (pageChanged)="onWeekPageChanged(week, $event)"
    >
      <div tableFooter class="team-table-footer">
        <ng-container *ngTemplateOutlet="statusLegend; context: { showIcons: true }"></ng-container>
      </div>
    </app-table>
  </section>
</ng-template>

<ng-template #statusLegend let-showIcons="showIcons">
  <div class="team-legend">
    <div class="team-legend__toggle-row">
      <button
        type="button"
        class="team-legend__toggle"
        [attr.aria-expanded]="showStatusInfo"
        aria-controls="statusInfo"
        (click)="showStatusInfo = !showStatusInfo"
      >
        <mat-icon aria-hidden="true">{{ showStatusInfo ? 'expand_less' : 'expand_more' }}</mat-icon>
        What do these statuses mean?
      </button>
    </div>
    <dl class="status-legend" id="statusInfo" *ngIf="showStatusInfo">
      <div class="status-legend__item" *ngFor="let item of statusLegendItems">
        <dt class="status-legend__term">
          <app-status-badge
            *ngIf="showIcons"
            class="status-legend__icon"
            aria-hidden="true"
            [label]="item.status"
            [tone]="getStatusTone(item.status)"
            [icon]="getDayStatusIcon(item.status)"
            [iconOnly]="true"
          ></app-status-badge>
          <app-status-badge
            *ngIf="!showIcons"
            [label]="item.status"
            [tone]="getStatusTone(item.status)"
          ></app-status-badge>
          <span *ngIf="showIcons" class="status-legend__name">{{ item.status }}</span>
        </dt>
        <dd class="status-legend__description">{{ item.description }}</dd>
      </div>
    </dl>
    <p class="my-team-disclaimer" *ngIf="showStatusInfo">
      This page only shows workspace bookings. It doesn't track attendance, leave or hours worked.
    </p>
  </div>
</ng-template>
